module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABV0lEQVRYR+3XTStFURQG4OcOJAMlZSQjSpKPYo7/YcBIxICZgWJkxoAwY2LoN/ATfEQUI+aUAUa069y67e7XuZ17r8HZdVqn1mq973rX2XuvU9DmVWgzvkYJDGIfU+jAE7ZwlbagRgj04w332E0ANzGaPA9pSDRC4AK9mIuALtGHaXzXSyItgR68Yw2HEcgqDjCCx2YRmEWoNFQf97uaryKftAq0jECostwKLZjENT6igGq+Ymj83VTchr8VtlRLCexgO6qy0RaEPDNldk5VBf4lgQWcYhFnkTrLOMIKjiNfJgp0JUfuAF4xjK8EqBN36MYnxvBTQiITAuO4QbC3mEhswAl3w3MJ4BBesiYQ8u1hPbmINiKZTzCPcyw1owX1nq7l4jJpQU4gVyBXIFcgV6AtCqQFDaNcWGHYDe+lNvVElBa8VnwY4+seSmsly8yf9r8gM+Bioj8FunkhsS2/cwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product_list/profile_shopping_cart.png
// module id = uf/Y
// module chunks = 0